import { useSelector, useDispatch } from "react-redux";
import {
  Document,
  View,
  Page,
  Text,
  PDFViewer,
  Image,
} from "@react-pdf/renderer";
import imgHt from "../../imagenes/imgHt.png";
import { format } from "date-fns";

export default function ClienteFaltantesPDF({ key, id, cliente, faltantes, faltantesSinParcial }) {
  let date = format(new Date(), "dd/MM/yyyy");

  const dispatch = useDispatch();
  

  
  console.log(cliente);
  console.log(id)
  console.log(faltantes);
  
 
  return (
    
    <PDFViewer style={{ width: "118vh", height: "90vh" }}>
      <Document>
        <Page size="A4" style={{display:"flex"}}>
        
          <View style={{display:"flex"}}>
            <View style={{ display: "flex"}}>
              <View
                style={{
                  widt: "200px",
                  height: "125px",
                  flexDirection: "row",
                  justifyContent: "space-between",
                }}
              >
          
                <View style={{ marginLeft: "40px" }}>
                  
                  <Image
                    href={imgHt}
                    style={{ width: "100px", height: "60px" }}
                  />
                  <View style={{ marginLeft: "11px" }}>
                   
                    <Text style={{ fontSize: "9pt" }}>Grupo HT</Text>
                    <Text style={{ fontSize: "9pt" }}>Pedro Lozano 5066</Text>
                    <Text style={{ fontSize: "9pt" }}>CABA</Text>
                    <Text style={{ fontSize: "9pt" }}>Argentina</Text>
                    <Text style={{ fontSize: "9pt" }}>Tel: 15-57619270</Text>
                    <Text style={{ fontSize: "9pt" }}>CUIT: </Text>
                  </View>
                </View>
                <View style={{ marginTop: "40px", marginRight: "40px" }}>
                 
                  <Text>Faltantes</Text>
                  <Text style={{ fontSize: "14pt" }}>
                   
                  </Text>
                  <Text> </Text>
                  <Text style={{ fontSize: "9pt" }}>
                    Fecha de Emisión: {date}
                  </Text>
                </View>
              </View>

              <View>
                <View
                  style={{
                    width: "530px",
                    height: "50px",
                    borderTop: "1px",
                    borderColor: "grey",
                    flexDirection:"row",
                    paddingTop:"5px",
                    marginLeft:"30px",                    
                  }}
                > 
                  <View style={{ flexDirection: "column", marginLeft:"10px", width:"185px"}}>
                    <Text style={{ fontSize: "9pt" }}>Compañia: {cliente.nameCompany}</Text>
                    <Text style={{ fontSize: "9pt", paddingTop:"5px"}}>Direccion: {cliente.address}</Text>
                  </View>
                  <View style={{marginLeft: "40px", width:"185px"}}>
                    <Text style={{ fontSize: "9pt" }}>Nombre: {cliente.name}</Text>
                    <Text style={{ fontSize: "9pt", paddingTop:"5px"}}>Telefonos: {cliente.telephoneNumber}</Text>
                  </View>
                  <View style={{marginLeft:"50px", width:"185px", marginRight:"5px"}}>
                    <Text style={{ fontSize: "9pt" }}>Apellido: {cliente.lastName}</Text>
                    <Text style={{ fontSize: "9pt", paddingTop:"5px"}}>Email: {cliente.email}</Text>
                  </View>
                </View>

                <View style={{
                    width: "530px",
                    height: "5px",
                    borderTop: "1px",
                    borderColor: "grey",
                    flexDirection:"row",
                    paddingTop:"5px",
                    marginLeft:"30px",                    
                  }}>
                </View>

                <View>
                  <Text style={{fontSize:"11pt", fontWeight:"bold", marginTop:"5px"}}>Faltantes en Estado Parcial</Text>
                </View>

                <View style={{display:"flex", flexDirection:"row", paddingTop:"5px", paddingBottom:"4px"}}>
                  <Text style={{fontSize:"11pt", width:"50px", border:"1px", borderColor:"black", textAlign:"center"}}>Rto</Text>
                  <Text style={{fontSize:"11pt", width:"300px", paddingLeft:"5px", border:"1px", borderColor:"black", textAlign:"center"}}>Nombre</Text>
                  <Text style={{fontSize:"11pt", width:"400px", border:"1px", borderColor:"black", textAlign:"center"}}>Descripcion</Text>
                  <Text style={{fontSize:"11pt", width:"80px", border:"1px", borderColor:"black", textAlign:"center"}}>Cantidad</Text>
                </View>
                
                <View>
                    {faltantes && faltantes.map((e) => (
                        <View key={e._id} style={{ flexDirection: "row" }}>
                        
                        {/* Número de documento (columna izquierda) */}
                        <View style={{
                            width: "50px",
                            borderWidth: 1,
                            borderColor: "#cbd5e1",
                            justifyContent: "center",
                            alignItems: "center"
                        }}>
                            <Text style={{ fontSize: "9pt" }}>
                            {e.document_id.numberDocument}
                            </Text>
                        </View>

                        {/* Contenedor de items */}
                        <View>
                            {e.itemsMissing.map((i) => (
                            <View
                                key={i.item}
                                style={{
                                flexDirection: "row",
                                borderWidth: 1,
                                borderColor: "#cbd5e1"
                                }}
                            >
                                <Text style={{ width: "300px", fontSize: "9pt" }}>
                                {i.name}
                                </Text>

                                <Text style={{ width: "400px", fontSize: "9pt" }}>
                                {i.descrip}
                                </Text>

                                <Text style={{
                                width: "80px",
                                fontSize: "9pt",
                                textAlign: "center"
                                }}>
                                {i.quantity}
                                </Text>
                            </View>
                            ))}
                        </View>

                        </View>
                    ))}
                    </View>
                  
                  {/*Faltantes completos*/}

                 
                <View>
                  <Text style={{fontSize:"11pt", fontWeight:"bold", marginTop:"5px"}}>Faltantes en Estado Negativo</Text>
                </View>

                <View style={{display:"flex", flexDirection:"row", paddingTop:"5px", paddingBottom:"4px"}}>
                  <Text style={{fontSize:"11pt", width:"50px", border:"1px", borderColor:"black", textAlign:"center"}}>Rto</Text>
                  <Text style={{fontSize:"11pt", width:"300px", paddingLeft:"5px", border:"1px", borderColor:"black", textAlign:"center"}}>Nombre</Text>
                  <Text style={{fontSize:"11pt", width:"400px", border:"1px", borderColor:"black", textAlign:"center"}}>Descripcion</Text>
                  <Text style={{fontSize:"11pt", width:"80px", border:"1px", borderColor:"black", textAlign:"center"}}>Cantidad</Text>
                </View>
                
                <View>
                    {faltantesSinParcial && faltantesSinParcial.map((e) => (
                        <View key={e._id} style={{ flexDirection: "row" }}>
                        
                        {/* Número de documento (columna izquierda) */}
                        <View style={{
                            width: "50px",
                            borderWidth: 1,
                            borderColor: "#cbd5e1",
                            justifyContent: "center",
                            alignItems: "center"
                        }}>
                            <Text style={{ fontSize: "9pt" }}>
                            {e.numberDocument}
                            </Text>
                        </View>

                        {/* Contenedor de items */}
                        <View>
                            {e.quantityItems.map((i) => (
                            <View
                                key={i.item}
                                style={{
                                flexDirection: "row",
                                borderWidth: 1,
                                borderColor: "#cbd5e1"
                                }}
                            >
                                <Text style={{ width: "300px", fontSize: "9pt" }}>
                                {i.name}
                                </Text>

                                <Text style={{ width: "400px", fontSize: "9pt" }}>
                                {i.descrip}
                                </Text>

                                <Text style={{
                                width: "80px",
                                fontSize: "9pt",
                                textAlign: "center"
                                }}>
                                {i.quantity}
                                </Text>
                            </View>
                            ))}
                        </View>

                        </View>
                    ))}
                    </View>


                  
                  {/* <View style={{height:"420px", marginLeft:"30px"}}>
                    {document.quantityItems.map(e=>
                      <View style={{display:"flex", flexDirection:"row", width:"530px", height:"15px", borderBottom:"1px", borderColor:"black", alignItems:"center"}}>
                        <View style={{width:"20px", alignContent:"center", borderRight:"1px", borderColor:"black"}}>
                        <Text style={{fontSize:"9pt", marginLeft:"5px"}}>{e.quantity}</Text>
                        </View>
                        <View style={{width:"185px", paddingLeft:"5px"}}>
                        <Text style={{fontSize:"9pt"}}>{e.name}</Text>
                        </View>
                        <View style={{width:"351px"}}>
                        <Text style={{fontSize:"9pt"}}>{e.descrip}</Text>
                        </View>
                      </View>
                    )}
                    </View> */}
                  
              </View>
            </View>
          </View>         
        </Page>
      </Document>
    </PDFViewer>
    
  );
}
